import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Radium from 'radium';

import reservedClassNames from 'globals/reservedClassNames';
import styles from './styles';
import { handleIconClick } from '../../app/App/actions';
import * as chatAppSelectors from '../../chat/app/ChatApp/selectors';

import IconDefault from '../IconDefault';
import IconDefaultColored from '../IconDefaultColored';
import IconCustom from '../IconCustom';
import IconUnreadBadge from '../IconUnreadBadge';
import IconMessages from '../messages/IconMessages';

export class Icon extends PureComponent {
  renderIconCustomOrDefault() {
    const { iconUrl, iconColor } = this.props;
    if (iconUrl) {
      return <IconCustom iconUrl={iconUrl} />;
    } else if (iconColor) {
      return <IconDefaultColored color={iconColor} />;
    }
    return <IconDefault />;
  }

  render() {
    const { handleClick } = this.props;
    return (
      <div>
        <IconMessages />
        <div className={reservedClassNames.appIcon} style={styles.icon} onClick={handleClick}>
          {this.renderIconCustomOrDefault()}
          <IconUnreadBadge />
        </div>
      </div>
    );
  }
}

Icon.propTypes = {
  handleClick: React.PropTypes.func,
  iconUrl: React.PropTypes.string,
  iconColor: React.PropTypes.string,
};

Icon.defaultProps = {
  handleClick: () => {},
  iconUrl: '',
  iconColor: null,
};

export const mapStateToProps = state => {
  return {
    iconUrl: chatAppSelectors.getCompanyIconUrl(state),
    iconColor: chatAppSelectors.getCompanyIconColor(state),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    handleClick() {
      dispatch(handleIconClick());
    },
  };
};

export const RadiumAppIcon = Radium(Icon);
export default connect(mapStateToProps, mapDispatchToProps)(RadiumAppIcon);
